// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3v7cI","info":"Note_info__1sn5l","note":"Note_note__17dC7","actions":"Note_actions__ziEDf"};